import { ArrowUpRight } from 'lucide-react';
import { ToolTileIcon } from '@/components/free-tools/platform-icon';
import { TrackedToolLink } from '@/components/free-tools/tracked-tool-link';
import type { FreeToolCtaSurface } from '@/components/free-tools/track-free-tool-cta';
import { freeToolHref, type FreeToolDefinition } from '@/lib/free-tools/registry';
import { cn } from '@/lib/utils';

export function FreeToolCard({
  tool,
  surface,
  fromSlug,
  className,
}: {
  tool: FreeToolDefinition;
  surface: FreeToolCtaSurface;
  fromSlug?: string;
  className?: string;
}) {
  return (
    <TrackedToolLink
      href={freeToolHref(tool.slug)}
      surface={surface}
      slug={fromSlug}
      label={tool.label}
      className={cn(
        'group flex h-full flex-col rounded-2xl border border-[rgb(var(--surface-border))] bg-[rgb(var(--surface))] p-5 transition-colors hover:border-[#8B5CF6]/60 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#8B5CF6]',
        className
      )}
    >
      <div className="mb-5 flex items-center justify-between">
        <ToolTileIcon tool={tool} />
        <ArrowUpRight
          aria-hidden
          className="h-4 w-4 text-[rgb(var(--foreground-secondary))] transition-colors group-hover:text-[#C4B5FD]"
        />
      </div>
      <h3 className="min-h-14 text-lg font-semibold leading-7 text-[rgb(var(--foreground))]">
        {tool.label}
      </h3>
      <p className="mt-2 flex-1 text-sm leading-6 text-[rgb(var(--foreground-secondary))]">
        {tool.description}
      </p>
      <span className="mt-5 text-sm font-medium text-[#C4B5FD]">Open tool</span>
    </TrackedToolLink>
  );
}
